import { useQuery } from '@tanstack/react-query'
import { requetes } from '../api'
import { LIBELLES_ACTION, LIBELLES_OBJET } from '../libelles'
import { Vide } from './Section'

export function formaterInstant(instant: string): string {
  return new Date(instant).toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    dateStyle: 'short',
    timeStyle: 'short',
  })
}

/** Historique (journal) filtré par entité ou par objet. */
export function Historique({ entiteId, objetId }: { entiteId?: string; objetId?: string }) {
  const journal = useQuery(
    requetes.journal({ ...(entiteId && { entiteId }), ...(objetId && { objetId }) }),
  )
  if (journal.isPending) return <Vide>Chargement…</Vide>
  if (!journal.data?.length) return <Vide>Aucune modification enregistrée.</Vide>
  return (
    <ul className="historique">
      {journal.data.map((l) => (
        <li key={l.id}>
          <span className="discret">{formaterInstant(l.creeLe)}</span>{' '}
          {LIBELLES_ACTION[l.action] ?? l.action} : {LIBELLES_OBJET[l.objetType] ?? l.objetType}
          <span className="discret">
            {' '}
            par {l.acteur ?? 'système'}
            {l.viaAssistant && ' (via l’assistant)'}
          </span>
        </li>
      ))}
    </ul>
  )
}
